import request from '@/utils/request'

/**
 * 删除 MinIO 上的图片（管理端上传组件「删除图片 / 重新上传」时调用）
 * 使用 POST + body，避免 DELETE query 被代理截断，并参与请求去重 key
 */
export const deleteImage = (url: string) => {
  return request({
    url: '/common/deleteImage',
    method: 'post',
    data: { url }
  })
}

/**
 * 上传图片：返回 OSS URL（供 imageUrl 字段保存）
 */
export const uploadImage = (file: File) => {
  const formData = new FormData()
  // 后端 CommonController.upload(MultipartFile file) 参数名为 file
  formData.append('file', file)
  return request({
    url: '/common/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
